import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContactDetails } from 'src/app/shared/models/ContactDetails';
import { PromoCodeRequestModel, PromoCodeResponseModel } from 'src/app/shared/models/PromoCodeModel';
import { PaymentDetailsModel } from '../../../shared/models/esignNextSteps';
import { OnboardingModel } from '../../../shared/models/ProductOnboarding';
import { FactoryhelperService } from "../../../shared/services/factoryHelper.service";

export type SilConsentResult = { EsignatureId: string };

@Injectable({
  providedIn: 'root'
})
export class UserOnboardingService {
  private apiUrl: string;
  private onboardingData: OnboardingModel;
  esignatureId: string;

  constructor(
    private readonly factoryhelperService: FactoryhelperService,
    private readonly translateService: AgTranslateService
  ) {
    this.apiUrl = AgAppConfigService.get<string>('applicativeApiUrl');
  }

  showsilsubscriptiondetails(personId: number, simulationId: number): Observable<unknown> {
    const culture = this.translateService.currentLang;
    const apiParams = new HttpParams({ fromString: `simulationId=${simulationId}` });
    const url = `${this.apiUrl}/${culture}/silproductonboarding/person/${personId}/simulation/simulationid/showsilsubscriptiondetails`;
    return this.factoryhelperService.get<{ Result: unknown }>(url, { params: apiParams }).pipe(map(x => x.Result));
  }

  saveBeneficiaryAnswer(simulationId: number, selectedAnswer: number): Observable<boolean> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/silproductonboarding/simulation/${simulationId}/savebeneficiaryanswer`;
    const data = {
      SimulationId: simulationId,
      BeneficiaryAnswer: selectedAnswer
    };
    return this.factoryhelperService.put<{ Result: boolean }>(url, data).pipe(map(x => x.Result));
  }

  savemandateanswer(personId: number, simulationId: number, Iban: string): Observable<boolean> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/silproductonboarding/simulation/${simulationId}/person/${personId}/savemandateanswer`;
    const data = {
      PersonId: personId,
      SimulationId: simulationId,
      IbanNumber: Iban,
      IsContractCreated: false
    };
    return this.factoryhelperService.put<{ Result: boolean }>(url, data).pipe(map(x => x?.Result));
  }

  updateSilConsents(personId: number, InvestmentConsent: boolean, promotionalConsent: boolean, partnerConsent: boolean, simulationId: number, partnerId: number, promoCodeId: number): Observable<SilConsentResult> {
    const culture = this.translateService.currentLang;
    // eslint-disable-next-line max-len
    const url = `${this.apiUrl}/${culture}/silproductonboarding/person/${personId}/quote/${simulationId}/partner/${partnerId}/promotionalemailsconsent/${promotionalConsent}/monitoringemailsconsent/${InvestmentConsent}/partnerconsent/${partnerConsent}/promoCodeId/${promoCodeId}/updatesilconsents`;
    return this.factoryhelperService.patch<{ Result: SilConsentResult }>(url, null).pipe(map(x => x?.Result));
  }

  public getNextSteps(esignId: string, esignStatus: boolean): Observable<PaymentDetailsModel> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/silproductonboarding/esign/${esignId}/status/${esignStatus}/getnextsteps`;
    return this.factoryhelperService.get<{ Result: PaymentDetailsModel }>(url).pipe(map(x => x?.Result));
  }

  public setOnboardingData(data: OnboardingModel): void {
    this.onboardingData = data;
  }

  public getOnboardingData(): OnboardingModel {
    return this.onboardingData;
  }

  public validatePromoCode(promoCodeReqObj: PromoCodeRequestModel): Observable<PromoCodeResponseModel> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/silproductonboarding/validateLeadPromoCode/promoCode/${promoCodeReqObj.PromoCode}/simulation/${promoCodeReqObj.SimulationID}`;
    return this.factoryhelperService.get<{ Result: PromoCodeResponseModel }>(url).pipe(map(x => x?.Result));
  }

  public getContactDetails(personId: number): Observable<ContactDetails> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/useraccount/getcontactdetails/person/${personId}`;
    return this.factoryhelperService.get<{ Result: ContactDetails }>(url).pipe(map(x => x?.Result))
  }
}
